import { useEffect, useState } from 'react';
import { MOBILE_BREAKPOINT } from '../../../../constants/componentStaticData';
import { Heading, HeadingType } from '../../../Typography';
import { useViewport } from '../../../hooks';
import { useCaseFoldCards } from './constants';
import { UseCaseAccordian } from './use-case-accordian';
import { UseCaseCard } from './use-case-card';
import { combineElements } from './utils';

export const UseCaseFold = (): JSX.Element => {
  const [windowWidth, setWidth] = useState(1024);
  const { width } = useViewport();
  const isMobile = windowWidth && windowWidth < MOBILE_BREAKPOINT;

  useEffect(() => {
    const { innerWidth: widthValue } = window;
    setWidth(widthValue);
  }, [width]);
  return (
    <div className="wg-container pt-28 pb-14 sm:pt-14 sm:pb-0">
      <Heading
        content={`We've got you covered. You name it, we got it. `}
        variant={HeadingType.h2}
        className="text-s-48 mb-6 sm:text-s-32 sm:mb-3"
      />
      <div className="flex flex-wrap -mx-6 relative">
        {isMobile
          ? useCaseFoldCards.map((card, idx) => {
              return (
                <UseCaseAccordian key={card.title} card={card} idx={idx} />
              );
            })
          : combineElements(useCaseFoldCards).map((cardArr, idx) => {
              const [card, card2] = cardArr;
              if (!card || !card2) return <></>;
              return (
                <div
                  className={`${
                    idx === 3 ? '' : 'useCaseCardWrapper'
                  } w-1/4 pr-[1px]`}
                  key={`${card.title}_${card2.title}`}
                >
                  <UseCaseCard card={card} />
                  <UseCaseCard card={card2} />
                </div>
              );
            })}
        <div className="useCaseSeparator w-full h-px top-1/2 absolute sm:hidden"></div>
      </div>
    </div>
  );
};
